import React from "react";
import LegoL99AData from "../dataDriven/LegoL99AData";
import websitesCards from "../dataDriven/websitesCards";

// Live demo: the data-driven L99A renders icon/logo + description cards from an
// array. Cards WITH `linkText` render as website cards (wide undistorted logo +
// linked title); cards WITHOUT it render as app cards (bold title + "Click image
// or this link to view." line). Here we show the website variant.
function L99ADataComponentCode() {
  return (
    <div>
      <LegoL99AData cards={websitesCards} />
    </div>
  );
}

export default L99ADataComponentCode;
